import {Logger} from "./logger";
import {TopicpromoCinema} from "./cinema/topicpromo_cinema";
import { onMount } from "@otto-ec/global-resources/dom";

onMount(".promo_topicpromo-cinema--container", (element: Element) => {
    Logger.group("[FT3 promo topicpromo]");
    Logger.count("Topicpromo Invocation");

    new TopicpromoCinema(element);
    Logger.groupEnd();
});